export default __webpack_public_path__ + "static/media/buyer-dash.c0924940.png";